import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { useLanguage } from '../context/LanguageContext';

export default function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const { login } = useAuth();
  const navigate = useNavigate();
  const { t } = useLanguage();

  const handleSubmit = async (event) => {
    event.preventDefault();
    setError('');
    try {
      await login(email, password);
      navigate('/feed');
    } catch (err) {
      setError(err?.response?.data?.message || t('auth.loginError'));
    }
  };

  return (
    <div className="card" style={{ maxWidth: 460, margin: '0 auto' }}>
      <h2 className="section-title">{t('auth.loginTitle')}</h2>
      <p className="section-subtitle">{t('auth.loginDesc')}</p>
      <form onSubmit={handleSubmit} className="list" style={{ marginTop: 24 }}>
        <div>
          <label className="muted">{t('auth.email')}</label>
          <input className="input" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required />
        </div>
        <div>
          <label className="muted">{t('auth.password')}</label>
          <input className="input" type="password" value={password} onChange={(e) => setPassword(e.target.value)} required />
        </div>
        {error ? <p style={{ color: 'var(--danger)' }}>{error}</p> : null}
        <button className="btn btn-primary" type="submit">
          {t('actions.login')}
        </button>
      </form>
    </div>
  );
}
